module.exports = __webpack_public_path__ + "static/media/user3.f749b8e1.jpg";